import moment, { Moment } from 'moment';

const getNoon = (date?: string) => {
  if (date) {
    return moment(date, 'YYYYMMDD').startOf('day').hour(12);
  }
  return moment().startOf('day').hour(12);
};

const getDayDifference = (startDate: Moment, endDate: Moment) => {
  return endDate.diff(startDate, 'days');
};

const getBlockedStartDays = (minDate: Moment, availabilityList: string) => {
  const days = new Set<string>();
  const firstElligibleDay = getDayDifference(minDate, getNoon());
  for (let i = firstElligibleDay; i < availabilityList.length; i++) {
    if (availabilityList.charAt(i) !== 'A') {
      const date = minDate.clone().add(i, 'days');
      days.add(date.format('YYYYMMDD'));
    }
  }
  return days;
};

const getHighlightedStartDays = (minDate: Moment, availabilityList: string) => {
  const days = new Set<string>();
  const firstElligibleDay = getDayDifference(minDate, getNoon());
  for (let i = firstElligibleDay; i < availabilityList.length; i++) {
    if (
      availabilityList.charAt(i) !== 'A' &&
      (i > 0 ? availabilityList.charAt(i - 1) === 'A' : false)
    ) {
      const date = minDate.clone().add(i, 'days');
      days.add(date.format('YYYYMMDD'));
    }
  }
  return days;
};

export {
  getNoon,
  getDayDifference,
  getBlockedStartDays,
  getHighlightedStartDays,
};
